import React from "react";
import { FaGithub, FaLinkedin, FaEnvelope, FaInstagram } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="w-full bg-transparent text-primaryText font-sans">
      {/* Divider */}
      <div className="max-w-7xl mx-auto px-6 sm:px-10">
        <div className="h-px bg-border/70 mb-8" />
      </div>

      {/* Footer content */}
      <div className="max-w-7xl mx-auto px-6 sm:px-10 pb-10 flex flex-col items-center gap-6">
        {/* Social icons */}
        <div className="flex gap-6 text-xl text-secondaryText">
          <a
            href="https://github.com/sirishalokanath"
            target="_blank"
            rel="noreferrer"
            className="hover:text-accent transition-colors duration-200"
          >
            <FaGithub />
          </a>
          <a
            href="https://www.linkedin.com/in/sirishalokanathraju/"
            target="_blank"
            rel="noreferrer"
            className="hover:text-accent transition-colors duration-200"
          >
            <FaLinkedin />
          </a>
          <a
            href="mailto:slraju0811@gmail.com"
            className="hover:text-accent transition-colors duration-200"
          >
            <FaEnvelope />
          </a>
          <a
            href="https://www.instagram.com/sirishalokanath"
            target="_blank"
            rel="noreferrer"
            className="hover:text-accent transition-colors duration-200"
          >
            <FaInstagram />
          </a>
        </div>

        {/* Copyright */}
        <p className="text-sm text-secondaryText text-center">
          © {new Date().getFullYear()} Sirisha Lokanath Raju. All Rights
          Reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
